import { format } from 'date-fns'
interface IGroup<U> {
    group: string;
    data: U;
}
export function groupBy<T, U>(array: T[], fn: (item: T) => IGroup<U>) {
    const groups: { [key: string]: U[] } = {};
    array.forEach((item) => {
        const result = fn(item);
        const group = JSON.stringify(result.group);
        groups[group] = groups[group] || [];
        groups[group].push(result.data);
    });
    return Object.keys(groups).map((group) => groups[group]);
}


export function strContains(s: string, c: string): boolean {
    if (typeof s != 'string' || typeof c != 'string') return false;
    return s.toLowerCase().indexOf(c.toLowerCase()) >= 0;
}

export function firstMatch(regex: RegExp, str: string, defVal: string): string[] {
    const match = regex.exec(str)
    if (match) return match;
    return [defVal];
}

export function formatDateTime(date: any) {
    return format(new Date(date), "yyyy-MM-dd-HHmmss");
}

export const jsonCopy = (obj: any) => JSON.parse(JSON.stringify(obj));